import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { PlusArchive } from "scmp-app/components/plus/archive";

export const StyledPlusArchive = styled(PlusArchive)`
  ${theme.breakpoints.only("mobile")} {
    display: none;
  }
`;
